export const SET_MYPLANS_DATA = "SET_MYPLANS_DATA";
export const MYPLANS_FETCH_INIT = "MYPLANS_FETCH_INIT";
export const DATA_FETCH_INIT = "DATA_FETCH_INIT";
